import { NavLink } from "react-router-dom";
import { useUser } from "../../hooks/User";
import { Icon } from "../icons";
import "./sideMenu.style.scss";

export const SideMenu = () => {

    const isLogged = useUser().getDataByAttributeName("isLogged");

    if(!isLogged){
        return null;
    }

    return(
        <div className="side-menu-wrapper">
            <div className="side-menu">
                <NavLink to={"/"} className={'menu-links'}>
                    {({isActive}) => <Icon type="menuHome" active={isActive}/>}
                </NavLink>
                {/* <NavLink to={"/my-process"} className={'menu-links'}>
                    {({isActive}) => <Icon type="menuProcess" active={isActive}/>}
                </NavLink> */}
                <NavLink to={"/profile"} className={'menu-links'}>
                    {({isActive}) => <Icon type="menuProfile" active={isActive}/>}
                </NavLink>
                {/* <NavLink to={"/help"} className={'menu-links'}>
                    {({isActive}) => <Icon type="menuHelp" active={isActive}/>}
                </NavLink> */}
            </div>
        </div>
    )
}